import { LoadingSpinner } from "components/LoadingSpinner";
import { useGetClaimsAnalysisUrlQuery } from "store/queries/analytics";

interface IClaimsAnalysisDashboardProps {
  accountId: string;
}

export function ClaimsAnalysisDashboard({
  accountId,
}: IClaimsAnalysisDashboardProps) {
  const { data, isLoading } = useGetClaimsAnalysisUrlQuery(
    { accountId },
    { skip: !accountId }
  );

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <div
      style={{
        width: "100%",
        height: "2800px",
        padding: "0",
        margin: "0",
      }}
    >
      {data?.data?.iframeUrl && (
        <iframe
          src={data.data.iframeUrl}
          frameBorder="0"
          width="1400"
          height="2800"
          title="Claims Analysis"
        />
      )}
    </div>
  );
}
